import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AnalyticsService } from '@core/services';
import {
  SearchStateService,
  RoomBookingService,
  CheckRoomService,
  ReqService,
  PriceService,
} from '@core/services';
import { IsEconomicPipe } from '@shared/pipes/is-economic.pipe';
import { TotalPriceComponent } from '../detail-cluster/total-price/total-price.component';
import { PaymentAdviseComponent } from '../detail-cluster/payment-advise/payment-advise.component';
import { MealPlanComponent } from '../detail-cluster/meal-plan/meal-plan.component';
import { RoomComponent } from '../room/room.component';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'detail-cluster-mobile',
    templateUrl: './detail-cluster-mobile.component.html',
    styleUrls: ['./detail-cluster-mobile.component.scss'],
    standalone: true,
    imports: [
        NgFor,
        RoomComponent,
        NgIf,
        MealPlanComponent,
        PaymentAdviseComponent,
        TotalPriceComponent,
        IsEconomicPipe,
    ],
})
export class DetailClusterMobileComponent implements OnInit, OnChanges {
  @Input()
  hotelAvailabilityInfo: any;
  @Input()
  priceByValue: any;
  @Input()
  cluster: any;
  @Input()
  index: any;
  @Input()
  showAmountTotal: any;
  @Input()
  hotelStaticInfo: any;
  @Input()
  isHomestay = false;

  public notAvailableRate: number;
  public loadingRate: number;
  public rateUnavailable: any;
  public ratePriceChange: any;
  public pricesModel: any;
  public rateOption: any;
  public isAlliance: boolean;
  public userCountry: string;
  public quantityNights: number;
  public quantityGuests: number;
  public quantityRooms: number;
  public bedInfo: any;
  public isArgentina: boolean;

  constructor(
    private roomBookingService: RoomBookingService,
    private reqService: ReqService,
    private checkRoomRateService: CheckRoomService,
    private searchStateService: SearchStateService,
    private analyticsService: AnalyticsService,
    private priceService: PriceService,
  ) {}

  ngOnInit() {
    const decodedRooms = this.searchStateService.getDecodedRooms();
    this.notAvailableRate = 0;
    this.loadingRate = 0;
    this.pricesModel = {};
    this.rateOption = { id: 0 };
    this.quantityNights = this.priceService.getData().nights;
    this.quantityRooms = this.priceService.getData().rooms;
    this.quantityGuests = decodedRooms.total;
    this.userCountry = this.reqService.getCountry();
    this.isAlliance = this.reqService.isAlliance();
    this.bedInfo = this.hotelAvailabilityInfo.rooms_detail
      ? this.hotelAvailabilityInfo.rooms_detail.find(
          (roomDetail) => roomDetail.id === this.cluster.rooms[0].id,
        )
      : '';
    this.isArgentina = ['1123215', 'NEW8'].includes(
      this.hotelAvailabilityInfo.country.id,
    );
  }

  ngOnChanges(_changes: SimpleChanges) {
    this.bedInfo = this.hotelAvailabilityInfo.rooms_detail
      ? this.hotelAvailabilityInfo.rooms_detail.find(
          (roomDetail) => roomDetail.id === this.cluster.rooms[0].id,
        )
      : '';
  }

  public showCommission(rate) {
    return rate.price.commission.value - rate.price.commission.tax;
  }

  public superclubPrice(rate) {
    return Math.ceil(this.showAmount(rate));
  }

  public showAmountPerNight(rate) {
    return {
      without_promo: this.priceService.getPriceWithoutDiscount(
        rate,
        'NIGHT',
        this.showAmountTotal,
      ),
      total: this.priceService.getPrice(rate, 'NIGHT', this.showAmountTotal),
    };
  }

  public showAmount(rate) {
    return this.priceService.getPrice(rate, 'TOTAL', this.showAmountTotal);
  }

  /**
   * Redirect to cart using the selected rate
   */
  public bookRate(rate) {
    if (this.roomBookingService.loading) {
      return false;
    } else {
      if (rate.isEconomic) {
        this.analyticsService.trackEvent({
          section: 'Detail',
          action: 'Economic Prepaid',
          label: 'Click',
        });
      }

      this.loadingRate = rate.id;
      if (rate.status === 'CHECKED_NO_CHANGE' || rate.status === 'CHECKED_CHANGE') {
        this.roomBookingService.bookRate(rate, this.hotelAvailabilityInfo).subscribe(
          (res: any) => {
            window.location.href = window.location.protocol + '//' + res.urlToRedirect;
          },
          () => (this.notAvailableRate = rate.id),
        );
      } else {
        this.checkRoomRateService.getRoomRate(rate).subscribe((res) => {
          switch (res.status) {
            case 'CHECKED_NO_CHANGE':
              this.bookRate(rate);
              break;
            case 'CHECKED_CHANGE':
              this.loadingRate = 0;
              const oldPrice = rate.price.show_amount_per_night_per_room;
              const newPrice = res.price.show_amount_per_night_per_room;
              this.ratePriceChange = oldPrice >= newPrice;
              rate.price.show_amount_per_night_per_room = newPrice;
              break;
            case 'UNVAILABLE':
              this.loadingRate = 0;
              this.rateUnavailable = this.cluster.rates.every((room) => {
                return room.status === 'UNVAILABLE';
              });
              break;
          }
          rate.status = res.status;
        });
      }
    }
  }
}
